import { pathBuilder } from 'config/paths/index';

export const root = '/admin/reportable-templates';
export default pathBuilder(root);
